import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/NavBar";
import { useAppDispatch, useAppSelector } from "../store/store";
import AuthAction from "../store/auth/action";
import type { ProfileEditParams } from "../models/auth/auth.params";

const ProfileEditPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { user, isLoading, error, updateProfileSuccess } = useAppSelector((s) => s.auth);

    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");
    const [date_of_birth, setDateOfBirth] = useState("");
    const [errors, setErrors] = useState<Record<string, string>>({});

    useEffect(() => {
        if (user) {
            setFirstName(user.first_name ?? "");
            setLastName(user.last_name ?? "");
            setDateOfBirth(user.date_of_birth ?? "");
        }
    }, [user]);

    useEffect(() => {
        return () => {
            AuthAction.clearState(dispatch);
        };
    }, [dispatch]);

    const validate = (): boolean => {
        const next: Record<string, string> = {};
        if (!first_name.trim()) next.first_name = "Ju lutemi shënoni emrin";
        if (!last_name.trim()) next.last_name = "Ju lutemi shënoni mbiemrin";
        if (!date_of_birth.trim()) next.date_of_birth = "Ju lutemi jepni datën e lindjes";
        setErrors(next);
        return Object.keys(next).length === 0;
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!validate() || !user) return;
        const body: ProfileEditParams = {
            first_name: first_name.trim(),
            last_name: last_name.trim(),
            date_of_birth: date_of_birth.trim(),
        };
        console.log('body', body);
        AuthAction.updateUserProfile(user, body, dispatch);
    };

    const onSuccessClose = () => {
        AuthAction.clearState(dispatch);
        navigate("/profile");
    };

    if (!user) {
        return (
            <div className="min-h-screen bg-[#f8f2ed] font-manrope">
                <Navbar />
                <div className="max-w-xl mx-auto px-4 py-6">Duke u ngarkuar...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#f8f2ed] font-manrope">
            <Navbar />
            <div className="max-w-xl mx-auto px-4 py-6">
                <Link to="/profile" className="text-[#704e37] text-sm font-medium mb-4 inline-block">← Prapa në profilin</Link>
                <h1 className="text-2xl font-semibold text-[#704e37] mb-4">Ndrysho profilin</h1>

                <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow p-6 space-y-4">
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Emri</label>
                        <input
                            value={first_name}
                            onChange={(e) => setFirstName(e.target.value)}
                            className="w-full border rounded px-3 py-2"
                            placeholder="Emri"
                        />
                        {errors.first_name && <p className="text-red-500 text-sm mt-0.5">{errors.first_name}</p>}
                    </div>
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Mbiemri</label>
                        <input
                            value={last_name}
                            onChange={(e) => setLastName(e.target.value)}
                            className="w-full border rounded px-3 py-2"
                            placeholder="Mbiemri"
                        />
                        {errors.last_name && <p className="text-red-500 text-sm mt-0.5">{errors.last_name}</p>}
                    </div>
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Data e lindjes</label>
                        <input
                            value={date_of_birth}
                            onChange={(e) => setDateOfBirth(e.target.value)}
                            className="w-full border rounded px-3 py-2"
                            placeholder="DD-MM-YYYY"
                        />
                        {errors.date_of_birth && <p className="text-red-500 text-sm mt-0.5">{errors.date_of_birth}</p>}
                    </div>
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Email</label>
                        <input
                            value={user.email ?? ""}
                            readOnly
                            className="w-full border rounded px-3 py-2 bg-gray-50 text-gray-600"
                        />
                    </div>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full py-3 rounded-lg bg-[#704e37] text-white font-medium hover:opacity-90 disabled:opacity-50"
                    >
                        {isLoading ? "Duke ruajtur..." : "Ruaj"}
                    </button>
                </form>
            </div>

            {updateProfileSuccess && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
                    <div className="bg-white rounded-xl shadow-lg max-w-sm w-full p-6 text-center">
                        <p className="font-medium text-gray-800 mb-1">Sukses</p>
                        <p className="text-gray-600 text-sm mb-4">Të dhënat e profilit u ndryshuan me sukses.</p>
                        <button onClick={onSuccessClose} className="w-full py-2.5 rounded-lg bg-[#704e37] text-white font-medium">
                            Mbyll
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileEditPage;
